<template>
  <div class="flex items-center px-5">
    <div class="flex-shrink-0">
      <img
          class="h-10 w-10 rounded-full"
          :src="user.avatar"
          :alt="user.name"
      >
    </div>
    <div class="ml-3">
      <div class="text-base font-medium text-gray-800">{{ user.name }}</div>
      <div class="text-sm font-medium text-gray-500">{{ user.email }}</div>
    </div>
    <NotificationBadge class="ml-auto" />
  </div>
</template>

<script setup>
defineProps({
  user: Object
})

const { t } = useI18n()
</script>